import React from "react";
import { Link } from "react-router-dom";
import { ArrowBigRight } from "lucide-react";

export default function Hero() {
  return (
    <section className="pm-heroz">
      <div className="pm-heroz__brand">
        <span className="pm-heroz__brand-tag">
          The only direct-to-DEX launchpad on Solana
        </span>
        <div className="pm-heroz__brand-row">
          <h1 className="pm-heroz__brand-title">
            <img
              className="pm-heroz__brand-face"
              src="/images/webp/logo-shake-with-drip-v2.webp"
              alt=""
              draggable={false}
              aria-hidden="true"
            />
            <span className="pm-heroz__brand-main">Slurp</span>
          </h1>
          <ArrowBigRight className="pm-heroz__arrow" aria-hidden="true" />
          <div className="pm-heroz__brand-actions">
            <Link to="/deploy-token" className="pm-cta pm-cta--hero pm-heroz__cta">
              Launch a token
            </Link>
            <a
              href="#all-tokens"
              className="pm-heroz__jump"
              onClick={(e) => {
                e.preventDefault();
                document
                  .getElementById("all-tokens")
                  ?.scrollIntoView({ behavior: "smooth", block: "start" });
              }}
            >
              Browse all tokens →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
